import { resolvedCtaUrl } from "@/journey/externalNavigation";

/** Wireframe 1 · Entry. */
export function EntryScreen({
  busy = false,
  onStart,
  onVisit,
}: {
  busy?: boolean;
  onStart: () => void;
  onVisit: () => void;
}) {
  return (
    <section className="panel entry-panel transparent-background" data-testid="entry">
      <div className="entry-hero" aria-hidden="true">
        <span className="entry-hero-orb" />
        <span className="entry-hero-ring" />
      </div>
      <h1>See it in<br /><em>your space.</em></h1>
      <p className="panel-note">A 30-second interactive preview of Rising Pixel&rsquo;s WebAR work.</p>
      {/*
        The button carries the acknowledgement itself. A capability check that
        finishes in under a frame should change this label and nothing else —
        swapping the whole screen for a spinner nobody can read is worse than
        not reacting at all.
      */}
      <button
        className="button-primary start-experience-button"
        type="button"
        onClick={onStart}
        disabled={busy}
        aria-busy={busy}
        data-ui-control
        data-testid="start"
      >
        <span>{busy ? "Checking…" : "Start"}</span>
        <i aria-hidden="true">{busy ? "·" : "→"}</i>
      </button>
      <a
        className="panel-link"
        href={resolvedCtaUrl()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onVisit}
        data-ui-control
      >
        Skip to website
      </a>
    </section>
  );
}
